module.exports = __webpack_public_path__ + "media/markers/aton_blu-2a22ac14.svg";